/**
 * Restituisce il testo tradotto dato un originale e una mappa traduzioni.
 * Priorità: se la lingua corrente è quella di default -> originale.
 * Altrimenti cerca chiave esatta, poi varianti normalizzate (es. en-GB per en).
 * Fallback: originale.
 *
 * @param {string} originalText
 * @param {Object<string,string>} translationsMap
 * @param {string} currentLanguage normalizzato (es. "en")
 * @param {string} defaultLanguage normalizzato (es. "it")
 * @returns {string}
 */
export const getTranslatedText = (originalText, translationsMap, currentLanguage, defaultLanguage) => {
  if (!originalText) return '';
  if (!translationsMap || typeof translationsMap !== 'object') return originalText;
  if (currentLanguage === defaultLanguage) return originalText;

  // Match esatto
  if (translationsMap[currentLanguage]) {
    return translationsMap[currentLanguage];
  }

  // Match per variante (es. en-GB, en-US)
  const possibleKeys = Object.keys(translationsMap).filter(key => {
    const normalizedKey = String(key).split('-')[0].toLowerCase();
    return normalizedKey === currentLanguage;
  });

  if (possibleKeys.length > 0) {
    const first = possibleKeys[0];
    if (translationsMap[first]) return translationsMap[first];
  }

  return originalText;
};


